import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide1: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Madonna <span>-</span>
            <br /> Erotica
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=WyhdvRWEWRw"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Astrid Fontenelle</S.Name>
          <S.Profile>
            Apresentadora do Saia justa e uma das primeiras VJs da MTV Brasil
          </S.Profile>
          <S.Text>
            “O vídeo que mais me marcou foi ‘Erotica’, da Madonna, por causa de
            todo o frisson da época. Eu trabalhava na MTV e o clipe chegou horas
            antes da exibição, ninguém podia assistir e aquele suspense foi
            despertando mais curiosidade. Daí, ver aquela mulher praticamente da
            minha idade, expressando lindamente seus desejos foi matador!
            ‘Erotica’ é o ‘Je t’aime... moi non plus’ da minha época!”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
